// extracted by mini-css-extract-plugin
module.exports = {"leftArrow":"App_leftArrow__1Ew3T","rightArrow":"App_rightArrow__-GGeR"};